import React, { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import Select from "react-select";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import SearchBar from "../../../../components/SearchBar";
import Pagination from "../../../../components/Pagination";
import { API_URL } from "../../../../constants";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";
import Dynamic_FilterForm from "../../../../components/Dynamic_FilterForm";
import ExportToExcel from "../../../../components/ExportToExcel";

const MyTaskIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Task "));
  }, [dispatch]);

  const [myTaskListData, setMyTaskListData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(150);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState(6736);
  const [apiStatus, setApiStatus] = useState(undefined);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [hoveredProject, setHoveredProject] = useState(null);

  useEffect(() => {
    fetchMyTaskListData();
    fetchGetAPiData();
  }, []);

  const fetchGetAPiData = async () => {
    try {
      let response;
      response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/task/addPageDetails`
      );

      if (response?.status === 200) {
        const projectOpt = response?.data?.data?.projectList?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setProjectOptions(projectOpt);
      }
    } catch (error) {
      console.error("Feching Error ", error);
    }
  };

  const fetchMyTaskListData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/my-task?P_ProjectID=`
      );

      if (response.status === 200) {
        setApiStatus(response.status);
        const cleanedData = response?.data?.data;
        setMyTaskListData(cleanedData || []);
        setLoading(false);
      } else {
        console.error("Failed to fetch tasks:", response.status);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const toggleGroup = (projectName) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [projectName]: !prev[projectName],
    }));
  };

  const handleAddNew = () => {
    navigate(`/my-task/add`);
  };

  const handleEditbtn = (id) => {
    navigate(`/my-task/edit/${id.ID}`);
  };

  // Compute paginated data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, myTaskListData.length);
  const paginatedData = myTaskListData.slice(startIndex, endIndex);

  // Filter data based on search term
  const filteredData = useMemo(() => {
    return paginatedData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [paginatedData, searchTerm]);

  // Group data by Project
  const groupedData = useMemo(() => {
    return filteredData.reduce((acc, item) => {
      if (!acc[item.Project]) {
        acc[item.Project] = [];
      }
      acc[item.Project].push(item);
      return acc;
    }, {});
  }, [filteredData]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const formDatas = [
    {
      name: "Project",
      type: "Select",
      options: [...projectOptions],
    },
  ];
  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleGetData = async (projectId) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/task/my-task?P_ProjectID=${
          filterFormData.find((o) => o.label === "Project")
            ? filterFormData.find((o) => o.label === "Project").value
            : ""
        }`
      );

      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setMyTaskListData(cleanedData || []);
        setLoading(false);
      } else {
        console.error("Failed to fetch filtered tasks:", response.status);
      }
    } catch (error) {
      console.error("Error fetching filtered tasks:", error);
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilterData([]);
    fetchMyTaskListData();
  };
  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="container-fluid p-0">
          {/* First row for mobile - search and filter */}
          <div className="row d-flex d-md-none">
            <div className="col-10 pe-1" style={{ marginBottom:"0px" }}>
              <SearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
            <div className="col-2 ps-1" style={{ marginBottom:"0px" }}>
              <div className="dropdown">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                >
                  <button
                    className="dropdown-toggle w-100"
                    type="button"
                    id="excel-btn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-funnel-fill"></i>
                  </button>
                </OverlayTrigger>
                <div>
                  <Dynamic_FilterForm
                    formData={formDatas || []}
                    handleReset={handleReset}
                    handleChange={handleChange}
                    handleGetData={handleGetData}
                    filterFormData={filterFormData}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Second row for mobile - export and add */}
          <div className="row d-flex justify-content-end d-md-none mb-2">
            <div className="col-1 p-0">
              <ExportToExcel
                data={myTaskListData}
                filename="ResourceReport.csv"
              />
            </div>
            <div className="col-3">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
              >
                <button id="Add-btn" className="w-100" onClick={handleAddNew}>
                  <i className="fa fa-plus"></i> Add
                </button>
              </OverlayTrigger>
            </div>
          </div>

          {/* Desktop layout - single row */}
          <div className="d-none d-md-flex justify-content-between">
            <div className="d-flex">
              <div className="me-1">
                <SearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              </div>
              <div className="dropdown">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                >
                  <button
                    className="dropdown-toggle"
                    type="button"
                    id="excel-btn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-funnel-fill"></i>
                  </button>
                </OverlayTrigger>
                <div>
                  <Dynamic_FilterForm
                    formData={formDatas || []}
                    handleReset={handleReset}
                    handleChange={handleChange}
                    handleGetData={handleGetData}
                    filterFormData={filterFormData}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="me-1">
                <ExportToExcel
                  data={myTaskListData}
                  filename="ResourceReport.csv"
                />
              </div>
              <div className="d-flex justify-content-end">
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
                >
                  <button id="Add-btn" onClick={handleAddNew}>
                    <i className="fa fa-plus"></i> Add
                  </button>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <Table bordered striped hover>
            <thead id="thcolor" className="text-center">
              <tr>
                <th style={{ width: "100px" }}>Task</th>
                <th style={{ width: "100px" }} className="text-center">
                  From
                </th>
                <th style={{ width: "100px" }} className="text-center">
                  To
                </th>
                <th style={{ width: "80px" }}>Assigned By</th>
                <th style={{ width: "80px" }}>Category</th>
                <th style={{ width: "80px" }}>Status</th>
                <th style={{ width: "80px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {apiStatus === undefined ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    <div>
                      <p>
                        <FaSpinner className="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr>
              ) : Object.entries(groupedData).length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    No Data Found
                  </td>
                </tr>
              ) : (
                Object.entries(groupedData).map(([projectName, items]) => {
                  const isExpanded = expandedGroups[projectName];
                  const isHovered = hoveredProject === projectName;

                  return (
                    <React.Fragment key={projectName}>
                      <tr
                        style={{
                          backgroundColor: isHovered ? "#DFEBFF" : "inherit",
                          color: isHovered ? "#000" : "inherit",
                          transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={() => setHoveredProject(projectName)}
                        onMouseLeave={() => setHoveredProject(null)}
                      >
                        <td
                          colSpan={7}
                          onClick={() => toggleGroup(projectName)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: isHovered ? "#DFEBFF" : "inherit",
                            color: isHovered ? "#000" : "inherit",
                            padding: "8px 16px",
                          }}
                        >
                          <strong>{projectName}</strong>
                          <span
                            className="float-end me-2"
                            style={{ color: isHovered ? "white" : "inherit" }}
                          >
                            <i
                              className={`fa ${
                                isExpanded ? "fa-minus" : "fa-plus"
                              }`}
                            ></i>
                          </span>
                        </td>
                      </tr>
                      {isExpanded &&
                        items.map((data, index) => (
                          <tr key={index} className="border">
                            <td style={{ width: "100px" }}>{data.Name}</td>
                            <td
                              style={{ width: "100px" }}
                              className="text-center"
                            >
                              {data.StartDate
                                ? moment(data.StartDate).format("DD-MMM-YYYY")
                                : null}
                            </td>
                            <td
                              style={{ width: "100px" }}
                              className="text-center"
                            >
                              {data.EndDate
                                ? moment(data.EndDate).format("DD-MMM-YYYY")
                                : null}
                            </td>
                            <td style={{ width: "80px" }}>{data.AssignedBy}</td>
                            <td style={{ width: "80px" }}>
                              {data.TaskCategory}
                            </td>
                            <td
                              style={{ width: "80px" }}
                              className="text-center"
                            >
                              {data.Status}
                            </td>
                            <td
                              style={{ width: "80px" }}
                              className="text-center"
                            >
                              <i className="bi bi-trash icons me-2"></i>
                              <i
                                className="bi bi-pencil-square icons"
                                onClick={() => handleEditbtn(data)}
                              ></i>
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={myTaskListData.length}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default MyTaskIndex;
